(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icona-announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.icona-announce').forEach(function(bar){
  var msgs = bar.querySelectorAll('.icona-announce-msg');
  if (msgs.length < 2) return;
  var current = 0;
  var speed = parseInt(bar.dataset.speed, 10) || 3000;
  setInterval(function(){
    msgs[current].classList.remove('icona-announce-msg--active');
    current = (current + 1) % msgs.length;
    msgs[current].classList.add('icona-announce-msg--active');
  }, speed);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icona-hero-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.icona-hero').forEach(function(hero){
  var slides = hero.querySelectorAll('.icona-hero-slide');
  var dots = hero.querySelectorAll('.icona-hero-dot');
  if (slides.length < 2) return;
  var current = 0;
  var speed = parseInt(hero.dataset.autoplay, 10) || 5000;
  var timer;

  function goTo(i){
    slides[current].classList.remove('icona-hero-slide--active');
    if (dots[current]) dots[current].classList.remove('icona-hero-dot--active');
    current = i;
    slides[current].classList.add('icona-hero-slide--active');
    if (dots[current]) dots[current].classList.add('icona-hero-dot--active');
  }
  function reset(){
    clearInterval(timer);
    timer = setInterval(function(){ goTo((current + 1) % slides.length); }, speed);
  }
  dots.forEach(function(dot){
    dot.addEventListener('click', function(){
      goTo(parseInt(dot.dataset.index, 10));
      reset();
    });
  });
  reset();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
